<template>
  <div class="KnowledgeOrder">
    <div class="titleBox">
      <div class="redBox"></div>
      <p>我的知识订单</p>
    </div>
    <div class="screening ">
      <el-row :gutter="40">
        <el-col :span="7">
          <el-row class="alignCenter">
            <el-col :span="5"><span>订单编号</span></el-col>
            <el-col :span="19">
              <el-input v-model="orderNo" placeholder="请输入订单编号"></el-input>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="9">
          <el-row class="alignCenter">
            <el-col :span="4"><span>下单时间</span></el-col>
            <el-col :span="20">
              <el-date-picker v-model="orderTime" type="daterange" range-separator="至" start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="7">
          <el-row class="alignCenter">
            <el-col :span="5"><span>知识名称</span></el-col>
            <el-col :span="19">
              <el-input v-model="orderNo" placeholder="请输入知识名称"></el-input>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row :gutter="40">
        <el-col :span="7">
          <el-row class="alignCenter">
            <el-col :span="5"><span>知识目录</span></el-col>
            <el-col :span="19">
              <el-select v-model="KnowledgeDirectory" placeholder="请选择">
                <el-option v-for="item in KnowledgeDirectorys" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="9">
          <el-row class="alignCenter">
            <el-col :span="4"><span>知识类型</span></el-col>
            <el-col :span="20">
              <el-select v-model="KnowledgeDirectory" placeholder="请选择">
                <el-option v-for="item in KnowledgeDirectorys" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="7">
          <el-button type="danger">重置</el-button>
          <el-button type="danger">查询</el-button>
        </el-col>
      </el-row>
    </div>
    <div class="searchResultList">
      <el-tabs v-model="activeName" type="card">
        <el-tab-pane name="1">
          <div slot="label">
            <span>全部</span>
          </div>
          <div class="tabContent">
            <el-table ref="filterTable" :data="tableData" style="width: 100%;margin-bottom: 20px;" @row-click="toggleRowExpansion">
              <el-table-column type="expand" width="48">
                <template slot-scope="props">
                  <ul class="list" v-if="props.row.children">
                    <li v-for="item in props.row.children" :key="item.id">
                      <img src="../../assets/images/shebei1.png" style="width: 150px;max-height: 100px;" />
                      <div>{{item.name}}</div>
                      <div>{{item.trial}}</div>
                      <div>{{item.orderAmount}}</div>
                      <div>{{item.ActualAmount}}</div>
                      <div style="width: 200px;">{{item.discountInfo}}</div>
                      <el-button type="info">详情</el-button>
                    </li>
                  </ul>
                  <ul v-else>
                    <li>暂无详情</li>
                  </ul>
                </template>
              </el-table-column>
              <el-table-column prop="haspayment" label="是否付款" width="154">
              </el-table-column>
              <el-table-column prop="orderNo" label="订单编号" width="154">
              </el-table-column>
              <el-table-column prop="PaymentNo" label="支付流水编号" width="154">
              </el-table-column>
              <el-table-column prop="orderAmount" label="订单总金额" width="154">
              </el-table-column>
              <el-table-column prop="ActualAmount" label="实际支付金额" width="154">
              </el-table-column>
              <el-table-column prop="name" label="用户" width="154">
              </el-table-column>
              <el-table-column prop="orderTime" label="下单时间" width="154">
              </el-table-column>
              <el-table-column prop="PaymentTime" label="支付时间" width="154">
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>
        <el-tab-pane name="2">
          <div slot="label">
            <span>已付款</span>
          </div>
        </el-tab-pane>
        <el-tab-pane name="3">
          <div slot="label">
            <span>未付款</span>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="paging">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage"
        :page-size="100" layout="prev, pager, next, jumper" :total="1000">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  export default ({
    name: 'KnowledgeOrder',
    data() {
      return {
        orderNo: "no1", //订单编号
        orderTime: "", //下单时间
        KnowledgeDirectory: "", //知识目录
        currentPage: 10,
        KnowledgeDirectorys: [{
          value: '选项1',
          label: '黄金糕'
        }, {
          value: '选项2',
          label: '双皮奶'
        }, {
          value: '选项3',
          label: '蚵仔煎'
        }, {
          value: '选项4',
          label: '龙须面'
        }, {
          value: '选项5',
          label: '北京烤鸭'
        }],
        activeName: "1", //激活的选项卡
        tableData: [{
          id: 1,
          haspayment: "已付款",
          orderNo: "125876025",
          PaymentNo: "000587",
          orderAmount: "257",
          ActualAmount: "100",
          orderTime: "2016-05-02",
          PaymentTime: "2016-05-02",
          name: '王小虎',
        }, {
          id: 2,
          haspayment: "已付款",
          orderNo: "125876025",
          PaymentNo: "000587",
          orderAmount: "257",
          ActualAmount: "100",
          orderTime: "2016-05-02",
          PaymentTime: "2016-05-02",
          name: 'xxx',
        }, {
          id: 3,
          haspayment: "已付款",
          orderNo: "125876025",
          PaymentNo: "000587",
          orderAmount: "257",
          ActualAmount: "100",
          orderTime: "2016-05-02",
          PaymentTime: "2016-05-02",
          name: '陈滔',
          children: [{
            imgSrc: "../../assets/images/shebei1.png",
            name: "加热器（均无相变）换热面积计算",
            trial: "2019年8月25日17:53前可试用100次",
            orderAmount: "215",
            ActualAmount: "10",
            discountInfo: "11月推广活动（全场免费）",
          }, {
            imgSrc: "",
            name: "加热器（均无相变）换热面积计算",
            trial: "2019年8月25日17:53前可试用100次",
            orderAmount: "215",
            ActualAmount: "10",
            discountInfo: "11月推广活动（全场免费）",
          }]
        }, {
          id: 4,
          date: '2016-05-03',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1516 弄'
        }],
      }
    },
    methods: {
      toggleRowExpansion: function(row) {
        this.$refs.filterTable.toggleRowExpansion(row);
      },
      handleSizeChange(val) {
        //console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        //console.log(`当前页: ${val}`);
      }
    }
  })
</script>

<style lang="scss" scoped>
  /* 去掉圆角,应该用风格控制来实现*/
  .screening>>>.el-input__inner {
    border-radius: $border-radius;
  }

  p{margin: 0px;padding: 0px;}

  .screening>>>.el-button--danger {
    border-radius: $border-radius;
  }
  .el-button{
    padding: 9px 20px;
  }
  .KnowledgeOrder {
    width: 1280px;
    margin: 0 auto;
    padding-top: 20px;
  }

  .alignCenter {
    display: flex;
    align-items: center;
    color: #444;
  }

  .screening {
    margin-top: 25px;
    margin-bottom: 40px;
  }

  .screening>>>.el-row {
    margin-bottom: 15px;
  }

  .screening>>>.el-input__inner {
    height: 35px;
  }

  .searchAction {
    text-align: right;
    padding-right: 80px;
  }

  .searchAction>>>.el-button {
    padding: 8px 18px;
  }

  .searchResultList>>>.el-tabs--card>.el-tabs__header {
    margin-bottom: 0px;
  }

  .searchResultList>>>.el-tabs--card>.el-tabs__header .el-tabs__nav {
    border: none;
  }

  .searchResultList>>>.el-tabs--card>.el-tabs__header .el-tabs__item {
    border: none;
    margin-right: 0px;
    margin-left: 6px;
    background: #F2F2F2;
    border: 1px solid rgba(204, 204, 204, 0.49);
    color: #666;
    height: 35px;
    line-height: 35px;
  }

  .searchResultList>>>.el-tabs--card>.el-tabs__header .el-tabs__item.is-active {
    background: $color-primary;
    color: #fff;
  }

  >>>.el-tabs--card>.el-tabs__header .el-tabs__item:hover{color: $color-primary;}

  .searchResultList>>>.el-tabs__nav {
    float: right;
  }

  .tabContent>>>.el-table th {
    background: #F2F2F2;
  }

  .tabContent>>>.el-table th {
    padding: 12px 0px;
    text-align: center;
  }

  .tabContent>>>.el-table td {
    text-align: center;
  }

  .list li {
    display: flex;
    margin: 15px 0px;
  }

  .list>li>img {
    width: 200px;
    display: inline-block;
  }

  .list li>div {
    width: 154px;
    display: inline-block;
    padding: 0px 8px;
  }

  .showdetail {
    background: #33CB99;
    padding: 3px 8px;
    color: #ffffff;
  }

  .list>>>.el-button {
    padding: 4px 8px;
    height: 28px;
    border-radius: 0px;
  }

  .list>>>.el-button--info {
    background: #33CB99;
    border-color: #33CB99;
  }

  .paging {
    display: flex;
  }

  .paging>>>.el-pagination {
    display: block;
    margin: 10px auto;
  }

  .paging>>>.el-pager li.active {
    color:$color-primary;
  }

  .paging>>>.el-pager li {
    font-size: 16px;
    font-weight: normal;
    color: #666;
  }
  >>>.el-table__row{cursor: pointer;}
  .titleBox {
    border-bottom: 1px solid #e6e7ec;
    margin-bottom: 15px;
    display: flex;
  }

  .titleBox>p {
    line-height: 28px;
    height: 32px;
    font-size: 18px;
    color: #222;
  }

  .redBox{
    height: 18px;
    margin-top: 4px;
    background: $color-primary;
    width: 4px;
    margin-right: 4px;
  }
</style>



// WEBPACK FOOTER //
// src/page/memberCenter/KnowledgeOrder.vue